module.exports = __webpack_public_path__ + "static/media/Diagnostics.de1c08b7.png";